module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-contact"
  }, [_c('header-prop', {
    staticClass: "header-prop-contact",
    attrs: {
      "title": "Hello",
      "subtitle": "how can we be of assistance?"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/noctorus.studio",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.twitter.com/noctorus",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.medium.com/@noctorus",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-medium"
  })])]), _vm._v(" "), _c('contact-section', {
    attrs: {
      "id": "section-contact"
    }
  }), _vm._v(" "), (false) ? _c('section-comment') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d8de1f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contact.vue
// module id = 799
// module chunks = 1